import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "view", "className"];
import React from 'react';
import { ArrowsRotateLeft } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';
import { formatDate } from '../../utils';
import { block } from '../../utils/cn';
import { Row } from './Row';
import './CalendarRow.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('search-calendar-row');
export function CalendarRow(_ref) {
  var item = _ref.item,
    view = _ref.view,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isMobileView = view === 'mobile';
  var agoYears = item.start ? (new Date().getTime() - new Date(item.start).getTime()) / (1000 * 60 * 60 * 24 * 365) : 0;
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("time", {
      className: b('time'),
      children: [formatDate(item.start, {
        weekday: isMobileView ? 'short' : 'long',
        month: isMobileView ? 'short' : 'long',
        day: '2-digit',
        year: agoYears >= 1 ? isMobileView ? '2-digit' : 'numeric' : undefined,
        timeZone: item.timezone
      }), ",", ' ', formatDate(item.start, {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: item.timezone
      }), ' ', "\u2013", ' ', formatDate(item.end, {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: item.timezone
      })]
    }), item.repetitionRule ? /*#__PURE__*/_jsx(Icon, {
      data: ArrowsRotateLeft,
      size: 12,
      className: b('repeat-icon')
    }) : null]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    description: description,
    item: item,
    className: b(null, className)
  }, otherProps));
}
// #sourceMappingURL=CalendarRow.js.map